<template>
  <vuestic-modal ref="modal" :large="true" :force="false">
    <div slot="title">CONSOLIDADO MENSUAL SUCURSALES (CON PERIODO CERRADO)</div>
    <table class="table  table-bordered table-striped">
      <thead class="thead-light">
      <tr>
        <th>MES</th>
        <th>VENTAS AÑO {{anio_anterior}}</th>
        <th>VENTAS AÑO {{anio_actual}}</th>
        <th>% RESPECTO AÑO ANTERIOR {{anio_anterior}}</th>
        <th>DIFERENCIA</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="totales.length === 0">
        <spring-spinner color="blue" :size="20"/>
      </tr>
      <tr :class="setClass(item)" class="font-weight-bold" v-else
          v-for="item in totales">
        <td class="pointer mouseHover" @click="mouseEnter(item)">{{item.mes}}</td>
        <td>{{item.venta_anio_anterior | currency}}</td>
        <td>{{item.venta_actual | currency}}</td>
        <td>{{porcentajeAnioAnterior(item) | setValue}} %</td>
        <td>{{diferencia(item) | currency}}</td>
      </tr>
      </tbody>
    </table>
    <mini-modal-mes ref="miniModal" :data-mes="dataMes" :mes="mes" :anio_anterior="anio_anterior"
                    :anio_actual="anio_actual"/>
  </vuestic-modal>
</template>

<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import makeQuery from "../../../api/helper";
  import axios from "axios"
  import {months} from "../js/months";
  import SpringSpinner from "epic-spinners/src/components/lib/SpringSpinner";
  import Message from "../../Componentes_Globales/message/Message";
  import MiniModalMes from "./miniModalMes";

  export default {
    name: "modalConsolidadoSucursal",
    components: {MiniModalMes, Message, VuesticModal, SpringSpinner},
    data() {
      return {
        show: false,
        anio_actual: "",
        anio_anterior: "",
        totales: [],
        mes: "",
        sucursalesConcat: [],
        months,
        dataMes: []
      }
    },
    methods: {
      openModal(datos) {
        this.$refs.miniModal.closeMessage()
        window.addEventListener("keyup", (event) => {
          if (event.key === "Escape") this.$refs.modal.close()
        })
        this.$refs.modal.open()
        this.totales = []
        this.sucursalesConcat = []
        this.getData(datos)
      },
      getData(datos) {
        let querys = []
        this.anio_actual = datos[0].anio
        this.anio_anterior = datos[0].anio_anterior
        datos.forEach(item => {
          const criteria = this.createQuery(item)
          querys.push(this.$axios.get("/finanzas/consolidado-ventas" + criteria))
        })
        axios.all(querys).then(axios.spread((...responses) => {
          responses.forEach(({data}) => {

            this.sucursalesConcat.push(...data.items)
          })
          months.forEach(item => {
            this.calcularPorMes(item.label.toUpperCase(), this.sucursalesConcat)
          })
        })).catch(console.error)
      },
      calcularPorMes(mes, data) {
        this.totales.push({
          mes,
          venta_actual: data.reduce((acc, current) => current.mes === mes ? acc += current["venta_actual"] : acc, 0),
          venta_anio_anterior: data.reduce((acc, current) => current.mes === mes ? acc += current["venta_anio_anterior"] : acc, 0)
        })
      },
      createQuery(item) {
        return makeQuery({
          filtros: [
            {field: 'anioAnterior', value: item.anio_anterior, operator: '='},
            {field: 'anio', value: item.anio, operator: '='},
            {field: 'sucursalId', value: item.sucursal_id, operator: '='}
          ]
        })
      },
      porcentajeAnioAnterior(item) {
        const total_neto = item.venta_actual !== undefined ? item.venta_actual : 0
        const diff = total_neto - item.venta_anio_anterior
        return Math.round((diff * 100) / item.venta_anio_anterior)
      },
      diferencia(item) {
        const total_neto = item.venta_actual !== undefined ? item.venta_actual : 0
        return total_neto - item.venta_anio_anterior
      },
      mouseEnter(item) {
        this.mes = item.mes
        this.$refs.miniModal.openMessage(item)
      },
      setClass(item) {
        const value = this.porcentajeAnioAnterior(item)
        if (value < 0)
          return "table-danger"
        if (value === 0)
          return "table-warning"
        if (value > 0)
          return "table-success"
      },

    },
    filters: {
      setValue(value) {
        if (isNaN(value)) return 0
        if (value === Infinity) return 0
        return value
      }
    }
  }
</script>

<style scoped>
  .mouseHover:hover {
    background-color: #4d4d4d !important;
    color: white;
    transition: all linear 300ms;
  }
</style>
